import * as React from "react";
import "./PieChartSet.css";
import { ReportLabel } from "../ReportLabel";

export interface PieChartSetProps {
    title: string;
    children: React.ReactChild[] | React.ReactChild;
}

export function PieChartSet(props: PieChartSetProps) {
    return (
        <div className="PieChartSet">
            <ReportLabel className="PieChartSet__title" title={props.title} />
            <div className="PieChartSet__charts">{props.children}</div>
        </div>
    );
}
